import ElementUi from 'element-ui'
import packageInfo from '../../package'
import Vue from 'vue'

const consoleStyle = 'background-color: black;color: #fadd9d;padding: 4px 6px;margin: 10px'

// 控制台打印vue、element 和 组件库 版本号
console.log(`%cElementUi v${ElementUi.version}`, consoleStyle)
console.log(`%c${packageInfo.name} v${packageInfo.version}`, consoleStyle)
console.log(`%cVue v${Vue.version}`, consoleStyle)
